module.exports = __webpack_public_path__ + "static/media/kubestronaut_logo.3bab36d8.png";